/*eslint @typescript-eslint/no-unused-vars: "off"*/
/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @interface RequestsUpdate
 */
export interface RequestsUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof RequestsUpdate
     */
    clear_notifications?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsUpdate
     */
    read?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof RequestsUpdate
     */
    request_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof RequestsUpdate
     */
    status?: RequestsUpdateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RequestsUpdate
     */
    vrm_view_status?: RequestsUpdateVrmViewStatusEnum;
}




/**
* @export
* @enum {string}
*/
export enum RequestsUpdateStatusEnum {
    ACCEPTED = 'ACCEPTED',
    ARCHIVED = 'ARCHIVED',
    CANCELED = 'CANCELED',
    CREATED = 'CREATED',
    UNARCHIVED = 'UNARCHIVED',
    VENDORINPROGRESS = 'VENDOR_IN_PROGRESS',
    VRMINPROGRESS = 'VRM_IN_PROGRESS'
}
/**
* @export
* @enum {string}
*/
export enum RequestsUpdateVrmViewStatusEnum {
    VENDORAPPROVED = 'VENDOR_APPROVED',
    VENDORDECLINED = 'VENDOR_DECLINED',
    VENDORINITIAL = 'VENDOR_INITIAL',
    VRMREQUESTED = 'VRM_REQUESTED'
}


